import {
    USER_PROFILE_LICENSE_LIMITS_REQUEST,
    USER_PROFILE_MONITORING_STATS_REQUEST,
    USER_PROFILE_PORTFOLIO_STATS_REQUEST,
    USER_PROFILE_DISTRAINTS_STATS_REQUEST,
} from './constants'

import config from '../../../../../../../../config'

export function licenseLimitRequest(sessionId) {
    return {
        type: USER_PROFILE_LICENSE_LIMITS_REQUEST,
        payload: {
            ...config.api.licenseLimits,
            qs: {
                sid: sessionId,
            },
        },
    }
}

export function monitoringStatsRequest(sessionId) {
    return {
        type: USER_PROFILE_MONITORING_STATS_REQUEST,
        payload: {
            ...config.api.userStatsMonitoring,
            qs: {
                sid: sessionId,
            },
        },
    }
}

export function portfolioStatsRequest() {
    return {
        type: USER_PROFILE_PORTFOLIO_STATS_REQUEST,
        payload: {
            ...config.api.userStatsPortfolio,
        },
    }
}

export function distraintsStatsRequest() {
    return {
        type: USER_PROFILE_DISTRAINTS_STATS_REQUEST,
        payload: {
            ...config.api.userStatsDistraints,
        },
    }
}
